// @flow

import uuid from 'uuid';
import {
  QUESTION_ADDED,
  QUESTION_UPDATED,
  QUESTION_ORDER_CHANGED,
  QUESTION_TYPE_CHANGED,
  QUESTION_DELETED,
} from '../actions/questions';
import { INITIAL_DATA_LOAD_SUCCESS } from '../actions';
import { reorderElements } from 'utils/ordering';
import type { Question, QuestionType } from '../types';

export type State = Array<Question>;

const createDefaultQuestion = (order: number): Question => ({
  id: uuid(),
  order: order,
  title: '',
  description: '',
  required: false,
  isNew: true,
  content: createDefaultContent('short-text'),
});

const isDefaultContentValid = (type: QuestionType) => {
  switch (type) {
    case 'dropdown':
    case 'checkbox':
    case 'radio':
    case 'images':
      return true;
    default:
      return false;
  }
};

export const createDefaultContent = (type: QuestionType) => {
  const base = {
    isValid: isDefaultContentValid(type),
    hasChanged: false,
    type,
    choices: [],
  };

  switch (type) {
    case 'images':
      return {
        ...base,
        multiSelect: false,
      };
    default:
      return base;
  }
};

const initialState: State = [createDefaultQuestion(0)];

export default (state: State = initialState, action) => {
  switch (action.type) {
    case INITIAL_DATA_LOAD_SUCCESS:
      return action.questions.map(q => ({
        ...q,
        isNew: false,
      }));
    case QUESTION_ADDED:
      return [...state, createDefaultQuestion(state.length)];
    case QUESTION_UPDATED:
      return state.map(item => {
        if (item.id !== action.question.id) {
          return item;
        } else {
          return {
            ...item,
            ...action.question,
          };
        }
      });
    case QUESTION_TYPE_CHANGED:
      return state.map(item => {
        if (item.id !== action.question.id) {
          return item;
        } else {
          return {
            ...item,
            ...action.question,
            content: createDefaultContent(action.questionType),
          };
        }
      });
    case QUESTION_ORDER_CHANGED:
      return reorderElements(state, action.question, action.order);
    case QUESTION_DELETED:
      return state.filter(q => q.id !== action.question.id);
    default:
      return state;
  }
};

export const getQuestions = (state: State) => state.questions;



// WEBPACK FOOTER //
// ./src/modules/survey/reducers/questions.js